import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import {
  PreviewDetailsContent,
  PreviewDetailsCoverage,
  PreviewDetailsDesc,
  PreviewDetailsWrapper,
  PreviewDetailsMoreCovers
} from "./styles";
import { useContext, useState } from "react";
import { Context } from "@components/useContext/context";
import { useOnload } from "@utils/useOnLoad";
import DOMPurify from "isomorphic-dompurify";
import ImageContainer from "@components/imageContainer";
import { resolvePath } from "@utils/resolvePath";
import Hyperlink from "@components/common/hyperlink";
import { analyticEvents as triggerAnalyticEvent } from "@actions/analyticEvents";
import { getRequestpayload } from "@utils/index";

const PreviewDetails = ({ children, ...props }) => {
  const { coverageList, displayText, subHeading, showLearnMore, actions } =
    props || {};
  const { isDesktop } = useContext(Context);
  const { on_click } = actions || {};

  const showMore = coverageList?.length > 6;

  const [expanded, setExpanded] = useState(false);

  const displayedAddons = expanded ? coverageList : coverageList?.slice(0, 6);

  const handleExpandClick = () => {
    if (!expanded && showMore) {
      const { data, journey } = getRequestpayload();
      triggerAnalyticEvent({
        edata: {
          product: data.product,
          action_name: "tap_btn_more_covers",
          action_type: "tap_btn"
        },
        odata: {
          journey
        },
        event_name: "action"
      });
    }
    setExpanded((prevExpanded) => !prevExpanded);
  };

  return (
    <Box>
      <PreviewDetailsWrapper width="auto">
        <PreviewDetailsDesc>
        <span
          style={{fontSize: isDesktop ? "14px" : "12px"}}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(subHeading)
          }}
        />

        {showLearnMore && (
          <Hyperlink
            clickHandler={() => {
              if (on_click?.length > 0) {
                on_click?.forEach((eachFunc: any) => {
                  typeof eachFunc.funCall === "function" &&
                    eachFunc.funCall(eachFunc.args);
                });
              }
            }}
            type="UNDERLINE"
            is_visible={true}
            text="Learn more"
            styles={{marginLeft: "3px"}}
          />
        )}
       </PreviewDetailsDesc>
       <PreviewDetailsDesc>{children}</PreviewDetailsDesc>
        <PreviewDetailsCoverage isDesktop={isDesktop}>
          {displayText}
        </PreviewDetailsCoverage>

        {displayedAddons?.map((item, index) => (
          <Flex key={index} margin="8px 0px 0px 0px" alignItems="center">
            <ImageContainer
              imgSrc={resolvePath("/images/Tick_black.svg")}
              width={15}
              height={15}
              alt={"tick"}
            />
            <PreviewDetailsContent
              isDesktop={isDesktop}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(item?.text)
              }}
            />
          </Flex>
        ))}

        {showMore && !expanded && (
          <Flex
            margin="8px 0px 0px 0px"
            alignItems="center"
            onClick={handleExpandClick}
            style={{ cursor: "pointer"}}
          >
            <PreviewDetailsMoreCovers
              isDesktop={isDesktop}
            >
              {coverageList.length - 6} more covers
              <img
                src={resolvePath("/images/icons/chevron-down.svg")}
                alt="down arrow"
                style={{ width: "16px", height: "16px" }}
              />
            </PreviewDetailsMoreCovers>
          </Flex>
        )}

        {expanded && showMore && (
          <Flex
            margin="8px 0px 0px 0px"
            alignItems="center"
            onClick={handleExpandClick}
            style={{ cursor: "pointer"}}
          ></Flex>
        )}
      </PreviewDetailsWrapper>
    </Box>
  );
};

export default PreviewDetails;
